<div class="experiment-dialog-header">
  <mat-toolbar id="dialog-titlebar" color="primary">
    <div>{{ data.isEditMode ? 'Edit' : 'Create' }} Experiment</div>
  </mat-toolbar>
</div>

<form [formGroup]="experimentForm" class="normal-form" (submit)="onSubmit()">
  <div mat-dialog-content class="experiment-dialog-content">
    <div class="experiment-controls-group">
      <mat-form-field appearance="outline" class="experiment-form-field">
        <mat-label>Name</mat-label>
        <input matInput id="name" type="text" data-testid="lp-experiment-dialog-name-input" aria-describedby="name-error" formControlName="name" />
        <mat-error id="name-error" *ngIf="experimentForm.controls.name.errors?.required">
          This field is mandatory.
        </mat-error>
      </mat-form-field>
      <ng-container *ngIf="(featureFlags$ | async)?.EnableDataInsightsPreview && !showOldForm()">
        <mat-form-field appearance="outline" class="experiment-form-field" subscriptSizing="dynamic">
          <mat-label>Study Type</mat-label>
          <mat-select id="study-type" data-testid="lp-experiment-dialog-studytype-select" formControlName="studyType" (selectionChange)="validateStudyType()">
            <mat-option *ngFor="let studyType of studyTypes" [value]="studyType.id">
              {{ studyType.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <mat-form-field appearance="outline" class="experiment-form-field" subscriptSizing="dynamic"
        *ngIf="experimentForm.controls.studyType.value === StudyType.ImportExcel || showOldForm()">
        <mat-label>Assay Name</mat-label>
        <input matInput id="assay-name" type="text" data-testid="lp-experiment-dialog-assayname-input" aria-describedby="assay-name-error" formControlName="assayName" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="experiment-form-field"
        *ngIf="experimentForm.controls.studyType.value !== StudyType.ImportExcel && !showOldForm()">
        <mat-label>Assay Name</mat-label>
        <mat-select id="assay-name-dropdown" data-testid="lp-experiment-dialog-assayname-select" formControlName="assayNameId">
          <mat-option *ngFor="let assayName of assayNames" [value]="assayName.id" [disabled]="!assayName.isActive">
            {{ assayName.name }}
          </mat-option>
        </mat-select>
        <mat-error id="assay-name-error" *ngIf="experimentForm.controls.assayNameId.errors?.required">
          Assay Name is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="experiment-form-field" subscriptSizing="dynamic"
        *ngIf="!(featureFlags$ | async)?.EnableDataInsightsPreview || showOldForm()">
        <mat-label>Protocol Number</mat-label>
        <input matInput id="protocol-number" type="text" data-testid="lp-experiment-dialog-protocolnumber-input" formControlName="protocolNumber" />
      </mat-form-field>
    </div>
    <div class="experiment-controls-group">
      <ng-container *ngIf="(featureFlags$ | async)?.EnableDataInsightsPreview && !showOldForm() && !showOldForm()">
        <mat-form-field appearance="outline" class="experiment-form-field" subscriptSizing="dynamic">
          <mat-label>Protocol Number</mat-label>
          <input matInput id="protocol-number" type="text" data-testid="lp-experiment-dialog-protocolnumber-input" formControlName="protocolNumber" />
        </mat-form-field>
      </ng-container>
      
      <mat-form-field appearance="outline" class="experiment-form-field" subscriptSizing="dynamic">
        <mat-label>Device Type</mat-label>
        <mat-select id="device-type" data-testid="lp-experiment-dialog-devicetype-select" formControlName="deviceType">
          <mat-option *ngFor="let device of devices" [value]="device.id" [disabled]="device.inactive">
            {{ device.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="experiment-form-field">
        <mat-label>Default Replicates</mat-label>
        <input matInput id="replicates" type="number" data-testid="lp-experiment-dialog-replicates-input" formControlName="replicates" max="1000" />
        <mat-error id="replicates-error-required" *ngIf="experimentForm.controls.replicates.errors?.required">
          Maximum 1000 replicates.
        </mat-error>
        <mat-error id="replicates-error-value" *ngIf="experimentForm.controls.replicates.errors?.max || experimentForm.controls.replicates.errors?.min">
          Replicates must be between 1 and 1000 inclusive.
        </mat-error>
      </mat-form-field>

      <div class="radio-and-created-by">
        <div class="experiment-type-group" *ngIf="!hideExperimentType">
          <label class="experiment-type-label">Experiment Type</label>
          <mat-radio-group class="radio-btns" formControlName="type">
            <mat-radio-button
              class="exp-radio-btn"
              *ngFor="let experimentTypeDisplayName of ExperimentTypeDisplayNames | keyvalue; let idx = index"
              [value]="ExperimentTypeIndexes.indexOf(experimentTypeDisplayName.key)">
              {{ experimentTypeDisplayName.value }}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <mat-form-field appearance="outline" class="experiment-form-field" subscriptSizing="dynamic"
          *ngIf="data.isEditMode || data.isReadOnly">
          <mat-label>Created By</mat-label>
          <input matInput data-testid="dialog-experiment-createdby-input" [value]="data.experiment.createdByName" disabled />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="experiment-dialog-actions">
    <div class="button-row" *ngIf="!data.isReadOnly">
      <button mat-raised-button color="warn" type="button" data-testid="lp-experiment-dialog-cancel-button" (click)="onCancel()" [disabled]="isLoading">Cancel</button>
      <button mat-raised-button color="primary" type="submit" data-testid="lp-experiment-dialog-ok-button" [disabled]="experimentForm.invalid || isLoading">
        Ok
      </button>
    </div>
    <div class="button-row" *ngIf="data.isReadOnly">
      <button mat-raised-button color="primary" type="button" data-testid="lp-experiment-dialog-close-button" (click)="onCancel()">Close</button>
    </div>
  </div>
</form>
